import { action, observable } from 'mobx'

import Ds from './ds'

class Orders {
  @observable ds = new Ds()
  @observable all = []
  @observable order = {}

  @action deleteOrder(id, callback) {
    let query = `mutation {
      deleteOrder(
        id: ${ id},
        hash: "${ localStorage.getItem('userHash')}"
      ) {
        id
      }
    }`

    this.ds.query(query, (data) => {
      if (callback) {
        callback()
      }
    })
  }

  @action loadAllOrders(callback) {
    const query = `{
      orders(
        status: ${ 1},
        hash: "${ localStorage.getItem('userHash')}"
      ) {
        id
        organizationId
        companyId
        company {
          name
        }
        quoteId
        quote {
          quoteType
          demo
          lease
          userId
          user {
            firstName
            lastName
          }
          service {
            name
          }
          carrier {
            name
          }
          paymentInterval {
            name
          }
          contractTerm {
            terms
          }
          hardwareTotal
          accessoriesTotal
          taxTotal
          oneTimeTotal
          serviceTotal
          featureTotal
          monthlyTotal
        }
        qbOrderNumber
        paymentId
        payment {
          id
          qbPaymentNumber
          qbOrderNumber
          orderId
          amount
          cardNumber
          cardType
          approvalCode
        }
        shippingTypeId
        trackingNumber
        orderStatus
        createdAt
      }
    }`

    console.log(query)

    this.ds.query(query, (res) => {
      this.all = res.orders.map((o) => {
        if (o.company) {
          o.companyName = o.company.name
        }
        
        if (o.quote) {
          if (o.quote.user) {
            o.userFirstName = o.quote.user.firstName
            o.userLastName = o.quote.user.lastName
            o.userFullName = o.quote.user.firstName + ' ' + o.quote.user.lastName
          }
  
          if (o.quote.quoteType) {
            o.quoteType = o.quote.quoteType
          }
  
          if (o.quote.service) {
            o.serviceName = o.quote.service.name
          }
  
          if (o.quote.paymentInterval) {
            o.paymentIntervalName = o.quote.paymentInterval.name
          }
  
          if (o.quote.carrier) {
            o.carrierName = o.quote.carrier.name
          }
  
          if (o.quote.contractTerm) {
            o.contractTermName = o.quote.contractTerm.terms
          }
  
          if (o.quote.oneTimeTotal) {
            o.oneTimeTotal = o.quote.oneTimeTotal
          }
  
          if (o.quote.monthlyTotal) {
            o.monthlyTotal = o.quote.monthlyTotal
          }
        }

        if (o.createdAt) {
          let dd = new Date(o.createdAt)
          let dateString = ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (dd.getUTCDate())).slice(-2) + '-' + dd.getUTCFullYear()
          o.formattedOrderDate = dateString
        }

        o.balance = 0
        o.paymentAmount = 0

        if (o.payment) {
          o.qbOrderNumber = o.payment.qbOrderNumber
          o.qbPaymentNumber = o.payment.qbPaymentNumber
          o.paymentAmount = o.payment.amount
          o.approvalCode = o.payment.approvalCode
          o.cardNumber = o.payment.cardNumber
          o.cardType = o.payment.cardType
          o.balance = o.oneTimeTotal - o.paymentAmount
        } else {
          o.balance = o.oneTimeTotal
        }

        return o
      })

      if (callback) {
        callback(this.orders)
      }
    })
  }

  @action loadOrder(orderId, qbItemArray, callback) {
    const query = `{
      orders(
        id: ${ orderId},
        hash: "${ localStorage.getItem('userHash')}"
      ) {
        id
        organizationId
        companyId
        company {
          name
        }
        qbOrderNumber
        quoteId
        quote {
          demo
          lease
          userId
          user {
            firstName
            lastName
          }
          serviceId
          carrier {
            name
          }
          paymentInterval {
            name
          }
          contractTerm {
            terms
          }
          serialNumbers
          activation
          shippingCost
          agreementId
          hardwareTotal
          accessoriesTotal
          taxTotal
          oneTimeTotal
          serviceTotal
          featureTotal
          monthlyTotal
          note
        }
        paymentId
        shippingTypeId
        trackingNumber
        createdAt
      }
    }`

    console.log(query)

    this.ds.query(query, (res) => {
      if (res.orders.length > 0) {
        this.order = res.orders.map((o) => {
          o.demoName = (o.quote.demo == 1 ? 'Demo' : '')

          o.leaseName = (o.quote.lease == 1 ? 'Lease' : '')

          if (o.quote.user) {
            o.userFirstName = o.quote.user.firstName
            o.userLastName = o.quote.user.lastName
            o.userFullName = o.quote.user.firstName + ' ' + o.quote.user.lastName
          }

          if (o.company) {
            o.companyName = o.company.name
          }

          if (qbItemArray) {
            qbItemArray.map((qb) => {
              if (qb.id == o.quote.serviceId) {
                o.serviceName = qb.name
                o.serviceDescription = qb.description
              }
            })
          }

          /*
          if (o.quote.service) {
            o.serviceName = o.quote.service.name
            o.serviceDescription = o.quote.service.description
          }
          */

          if (o.quote.paymentInterval) {
            o.paymentIntervalName = o.quote.paymentInterval.name
          }

          if (o.quote.carrier) {
            o.carrierName = o.quote.carrier.name
          }

          if (o.quote.contractTerm) {
            o.contractTermName = o.quote.contractTerm.terms
          }

          if (o.quote.hardwareTotal) {
            o.hardwareTotal = o.quote.hardwareTotal
          }

          if (o.quote.accessoriesTotal) {
            o.accessoriesTotal = o.quote.accessoriesTotal
          }

          if (o.quote.activation) {
            o.activation = o.quote.activation
          }

          if (o.quote.shippingCost) {
            o.shippingCost = o.quote.shippingCost
          } else {
            o.shippingCost = 0
          }

          if (o.quote.agreementId) {
            o.agreementId = o.quote.agreementId
          }

          if (o.quote.taxTotal) {
            o.taxTotal = o.quote.taxTotal
          } else {
            o.taxTotal = 0
          }

          if (o.quote.oneTimeTotal) {
            o.oneTimeTotal = o.quote.oneTimeTotal
          }

          if (o.quote.serviceTotal) {
            o.serviceTotal = o.quote.serviceTotal
          }

          if (o.quote.featureTotal) {
            o.featureTotal = o.quote.featureTotal
          }

          if (o.quote.monthlyTotal) {
            o.monthlyTotal = o.quote.monthlyTotal
          }

          if (o.quote.note) {
            o.note = o.quote.note
          }

          if (o.quote.serialNumbers) {
            o.serialNumbers = o.quote.serialNumbers
          }

          if (o.createdAt) {
            let dd = new Date(o.createdAt)
            let dateString = ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (dd.getUTCDate())).slice(-2) + '-' + dd.getUTCFullYear()
            o.formattedOrderDate = dateString
          }

          return o
        })[0]

        if (callback) {
          callback(this.order)
        }
      }
    })
  }
}

export default new Orders()



// WEBPACK FOOTER //
// ./src/stores/orders.js